import { Component, Input } from '@angular/core';
import {
  normalizeCertificationStatus,
  resolveCertificationStatusIcon
} from '../../utils/certification-status.util';

@Component({
  selector: 'app-status-badge',
  standalone: false,
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent {
  @Input() status = '';
  @Input() iconWidthPx = 24;

  get iconSrc(): string {
    return resolveCertificationStatusIcon(this.status) || '';
  }

  get hasIcon(): boolean {
    return !!this.iconSrc;
  }

  get tooltipText(): string {
    return normalizeCertificationStatus(this.status);
  }
}
